<div class="mr-[80px] w-full" [class.form-error]="state.formControlErrors">
  <div class="flex w-full h-full invisible-highlighted-input">
    <input
      matInput
      type="text"
      [formControl]="formControl"
      [errorStateMatcher]="errorMatcher"
      class="font-semibold w-full h-full"
      autocomplete="off"
      [maxLength]="inputMaxLength"
      placeholder="Title here *"
      (blur)="onBlurInput()"
    />
    <mat-hint class="item-input-length" *ngIf="formControl.value.length > 0"
      >{{ formControl.value.length }} / {{ inputMaxLength }}
    </mat-hint>
  </div>
  <mat-error *ngIf="state.formControlErrors?.['required']" class="mat-error-default">Title is required</mat-error>
  <mat-error *ngIf="state.formControlErrors?.['unique']" class="mat-error-default">Title is already used</mat-error>
</div>
